import { anatomyToLine } from "./index3.js";
import { DefaultCorridor, GetAllBones, RG_TYPE, RgCreate } from "@project-rouge/rg-core";
import { CopyAcrossFloors, RgShallowClone, SignedAngle, TranslateAndRotate, Vectors, getPivot } from "@project-rouge/rg-three";
import { Line3, Vector3 } from "three";
const AddCorridorsToAnatomy = (building, dataset) => {
	if (!building.data.anatomy) return;
	const corridors = [];
	const bones = GetAllBones(building.data.anatomy);
	for (const bone of bones) {
		const { corridor } = createCorridor({
			bone,
			dataset
		});
		corridors.push(corridor);
		building.children = building.children.concat(CopyAcrossFloors({
			list: [corridor].map(RgShallowClone),
			floors: bone.floors,
			height: dataset.aggConfig.f2fHeight,
			yStart: 0
		}));
	}
	if (!dataset.aggConfig.gridCellWidth) return;
	const jointToCore = /* @__PURE__ */ new Map();
	for (const bone of bones) {
		if (bone.joints.every((j) => j.bones.every((b) => b.floors <= bone.floors))) continue;
		const connectedBones = bone.joints.map((j) => j.bones.filter((b) => b !== bone)).flat();
		for (const boneB of connectedBones) {
			if (boneB.floors <= bone.floors) continue;
			const core = getGfCornerCore({
				jointToCore,
				bone,
				boneB,
				building
			});
			const { corridor } = createCorridor({
				bone,
				dataset,
				fromEnd: boneB.joints.includes(bone.joints[1]),
				snapToCore: core,
				tendonID: boneB.tendon.id
			});
			corridors.push(corridor);
			building.children.push(...CopyAcrossFloors({
				list: [corridor].map(RgShallowClone),
				floors: boneB.floors - bone.floors,
				height: dataset.aggConfig.f2fHeight,
				yStart: bone.floors * dataset.aggConfig.f2fHeight
			}));
		}
	}
};
var _tendonLine = new Line3();
var _tendonVector = new Vector3();
var _pivot = new Vector3();
function createCorridor({ bone, dataset, fromEnd = false, snapToCore, tendonID = bone.tendon.id }) {
	const corridor = RgCreate({
		...DefaultCorridor,
		size: [
			0,
			dataset.aggConfig.f2fHeight,
			dataset.aggConfig.corridorWidth
		],
		anchor: [
			0,
			0,
			.5
		],
		data: {
			level: -1,
			levelId: "",
			tendonID
		}
	}, dataset.rvData);
	const tLine = anatomyToLine(bone.tendon, _tendonLine);
	if (fromEnd) {
		const start = tLine.start;
		tLine.start = tLine.end;
		tLine.end = start;
	}
	tLine.delta(_tendonVector);
	let size = _tendonVector.length();
	if (snapToCore) {
		let param = -Infinity;
		for (const pivot of [[
			0,
			0,
			0
		], [
			1,
			0,
			1
		]]) {
			getPivot(pivot, snapToCore, _pivot);
			const newParam = tLine.closestPointToPointParameter(_pivot);
			if (newParam > param) param = newParam;
		}
		size *= param;
	}
	corridor.size[0] = size;
	const angle = SignedAngle(Vectors.Right, _tendonVector);
	TranslateAndRotate([corridor], angle, tLine.start);
	return {
		corridor,
		tLine
	};
}
function getGfCornerCore({ jointToCore, bone, boneB, building }) {
	const joint = bone.joints.find((j) => boneB.joints.includes(j));
	if (!jointToCore.has(joint.id)) {
		const gfCornerCores = building.children.filter((c) => c.type === RG_TYPE.Core && c.data.isCorner && c.data.jointID);
		for (const core of gfCornerCores) {
			if (jointToCore.has(core.data.jointID)) continue;
			jointToCore.set(core.data.jointID, core);
		}
	}
	return jointToCore.get(joint.id);
}
export { AddCorridorsToAnatomy };

//# sourceMappingURL=index4.js.map